// extracted by mini-css-extract-plugin
module.exports = {"dropdownList":"Dropdown-List--dropdownList--2X7t6"};